import { useDispatch } from "react-redux";
import React, { useState } from "react";
import {
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";

import { useAxios } from "../../../hooks";
import { TextField } from "../../../components";
import { TextFifteenYellow, colors } from "../../css components/Style";
import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../css components/Button";
import { alert } from "../../../redux/slices/alertSlice";
import { Link } from "react-router-dom";

export default function VerifyOTPDialog({
  verifyOTP,
  setVerifyOTP,
  formikProps,
  brandID,
  agencyID,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    resend: false,
    verify: false,
  });

  const handleClose = () => {
    formikProps.setValues({
      ...formikProps.values,
      otp: "",
    });
    setVerifyOTP(false);
  };

  return (
    <React.Fragment>
      <MUIDialog
        slotProps={{
          paper: {
            sx: {
              borderRadius: "16px",
              padding: "24px",
              minWidth: "420px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
            },
          },
        }}
        open={verifyOTP}
        onClose={handleClose}
      >
        <DialogContent>
          <Grid container spacing={8}>
            <Grid size={12} style={{ textAlign: "center" }}>
              <TextFifteenYellow style={{ color: colors.sprintexBlue }}>
                Verify OTP
              </TextFifteenYellow>
            </Grid>

            <Grid size={12}>
              <TextField
                formikProps={formikProps}
                type="number"
                name="otp"
                size="small"
                label="Enter OTP"
                placeholder="Enter OTP"
              />
            </Grid>

            <Grid size={6}>
              <Typography>
                OTP sent on Mobile No : {formikProps.values.companyContact}
              </Typography>
            </Grid>

            <Grid size={6} style={{ textAlign: "end" }}>
              <Link
                style={{
                  textDecoration: "none",
                  color: loading.resend ? "#808080" : colors.sprintexBlue,
                  pointerEvents: loading.resend && "none",
                }}
              >
                <Typography onClick={resendOTP} autoFocus>
                  Resend OTP
                </Typography>
              </Link>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions style={{ padding: "24px" }}>
          <Grid container spacing={2}>
            <Grid size="auto">
              <CancelButton
                onClick={handleClose}
                variant="outlined"
                color="primary"
              >
                Cancel
              </CancelButton>
            </Grid>

            <Grid size="auto" offset={{ xs: "auto" }} />

            <Grid size="auto">
              <PrimaryLoadingButton
                loading={loading.verify}
                variant="contained"
                color="primary"
                autoFocus
                disabled={!formikProps.values.otp}
                onClick={verificationOTP}
              >
                Verify OTP
              </PrimaryLoadingButton>
            </Grid>
          </Grid>
        </DialogActions>
      </MUIDialog>
    </React.Fragment>
  );

  function verificationOTP() {
    setLoading({ ...loading, verify: true });
    axios({
      url: "/verify/otp",
      method: "POST",
      disableRedirect: true,
      data: {
        mobile_number: formikProps.values.companyContact,
        msg_type: "registration",
        otp: formikProps.values.otp,
        ...(!!brandID && { brand_id: parseInt(brandID) }),
        ...(!!agencyID && { agency_id: parseInt(agencyID) }),
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          verifyNumber: true,
          otp: "",
        }));

        dispatch(
          alert({
            type: "success",
            message: "Phone Number Verified Successfully",
          })
        );
        setVerifyOTP(false);
      }

      setLoading({ ...loading, verify: false });
    });
  }

  function resendOTP() {
    setLoading({ ...loading, resend: true });

    axios({
      url: "/send/otp",
      method: "POST",
      disableRedirect: true,
      data: {
        mobile_number: formikProps.values.companyContact,
        msg_type: "registration",
        resend: true,
        brand_id: parseInt(brandID),
      },
    }).then((response) => {
      if (response.status) {
        dispatch(
          alert({
            type: "success",
            message: "OTP sent successfully",
          })
        );
      }
      setLoading({ ...loading, resend: false });
    });
  }
}
